import styled from 'styled-components/macro';
import {CSS_MOBILE_BREAKPOINT,CSS_LOWSCREEN_BREAKPOINT} from '../constants';
import arrow_scrolldown_svg from '../assets/arrow_scrolldown.svg';

const ScrolldownStyled = styled.div`
	position:sticky;
	bottom:0;
	left:0;
	right:0;
	background-repeat: no-repeat;
	backdrop-filter: blur(2px);
	-webkit-backdrop-filter: blur(2px);
	background-color:rgba(248,248,248,0.8);
	mask: linear-gradient(180deg, transparent 0%, #000 20px);
	z-index: 4;
	padding-top:10px;
	.scrolldown-arrow {
		background-image: url(${arrow_scrolldown_svg});
		background-repeat: no-repeat;
		height:40px;
		background-position: 50% 50%;
	}
	@media ${CSS_MOBILE_BREAKPOINT} and ${CSS_LOWSCREEN_BREAKPOINT}{
		display: none;
	}
`;


function Scrolldown() {
	return (
		<ScrolldownStyled>
			<div className="scrolldown-arrow"/>
		</ScrolldownStyled>
	);
}

export default Scrolldown;
